/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import store from '../../redux/store';
import Listings from './components/Listings';
import TableLoader from '../../components/TableLoader';
import * as pricingActions from '../../redux/actions/pricing';
import * as refreshGroupActions from '../../redux/actions/refresh-groups';
import { updateEvent } from '../../helpers/api';
import { useQueryListings } from '../../hooks';
import { setCompAllGroup, validateGroupChanges, saveGroupChanges } from '../../helpers/pricing';
import { MARKETPLACES_TABS, DEFAULT_MARKETPLACE, PUSH_TO_SB_ENABLE } from '../../helpers/constants';
import { setGroupsAction, updateGroupFields, setPushEnableAction } from '../../redux/actions/refresh-groups';
import { setCompAllGroupAction, setVenueAvailableAction } from '../../redux/actions/groups-listings';
import { setCompAllEventAction } from '../../redux/actions/groups-listings-seating';
import { setActiveMarketplace } from '../../redux/actions/globals';

const ListingsContainer = ({
  actions,
  activeMarketplace,
  eventInfo,
  eventMeta,
  focusedPricingGroup,
  focusedPricingGroupMarketplace,
  groupActions,
  isCompAllEvent,
  isCompAllGroup,
  isVenueAvailable,
  setRefresh,
  typeListing,
  zones,
}) => {
  const [tabIndex, setTabIndex] = useState(MARKETPLACES_TABS[DEFAULT_MARKETPLACE]);
  const { data: dataLN = null, isFetching: isFetchingLN, refetch: refetchLN } = useQueryListings(eventMeta);
  const marketplaceName = tabIndex === 0 ? 'ticketnetwork' : 'seatgeek';
  const [forceVenue, setForceVenue] = useState(true);

  const validateChanges = (
    groupEdited,
    field,
    groupId,
    checkValue = false,
    initValue = null,
    currentValue = null,
    comingFrom = null
  ) => {
    let id = 0;
    let enablePush = {};
    const { groupFields, isPushEnable, initialGroups } = store.getState().refreshGroups;
    if (initialGroups && Array.isArray(initialGroups) && initialGroups.length > 0) {
      if (groupEdited) {
        id = groupEdited.id;
        const initGroup = initialGroups.find(init => init.id === id);
        enablePush = validateGroupChanges(initGroup, groupEdited, field);
      } else {
        id = groupId;
        const isEnablePush = PUSH_TO_SB_ENABLE.includes(field);
        if (checkValue && isEnablePush) {
          if (Array.isArray(initValue) && Array.isArray(currentValue)) {
            const hasChanged =
              initValue.length !== currentValue.length || JSON.stringify(initValue) !== JSON.stringify(currentValue);
            enablePush = { enablePush: isEnablePush, hasChanged };
          }
        }
      }
      const { newGroupFieldsToUpdate, pushEnableUpdateValue } = saveGroupChanges(
        id,
        enablePush,
        isPushEnable,
        field,
        groupFields,
        comingFrom
      );
      if (Object.keys(newGroupFieldsToUpdate).length > 0) {
        store.dispatch(updateGroupFields(newGroupFieldsToUpdate));
      }
      store.dispatch(setPushEnableAction(pushEnableUpdateValue));
    }
  };

  const activeMarketData = marketType => {
    if (dataLN && Array.isArray(dataLN) && dataLN.length > 0) {
      return dataLN.find(d => d?.response?.market === marketType);
    }
  };

  const addAllSections = (isCompAll, marketplace = '') => {
    let compAllZones = [];
    // If no value is sent in marketplace then set typeListing as marketplace to take data from
    const market = marketplace === '' ? typeListing : marketplace;
    if (isCompAll) {
      if (zones[market]) {
        zones[market].map(z => {
          const temp = z.sections.map(s => {
            return {
              zone_name: z.name,
              section_name: s.name,
              canonical_name: s.canonical_name ? s.canonical_name : s.name,
              zone_type: '',
              low_row: '',
              high_row: '',
            };
          });
          compAllZones = [...compAllZones, ...temp];
        });
      }
    }
    actions.setFormTNComparisonData(compAllZones);
    if (!isCompAll) {
      groupActions.updateGroupsMarketplaceComps('ticketnetwork', focusedPricingGroup, compAllZones);
      groupActions.updateGroupsMarketplaceComps('seatgeek', focusedPricingGroup, compAllZones);
    }
    groupActions.updateGroupsMarketplaceComps(market, focusedPricingGroup, compAllZones);
  };

  const getVenueData = () => {
    if (dataLN && Array.isArray(dataLN) && dataLN.length > 0) {
      return dataLN.reduce((acc, item) => {
        if (item && item.response) {
          acc[item.response.market] = item.response.venue;
        }
        return acc;
      }, {});
    }
    return {};
  };

  const groupsUpdateReArrange = newGroup => {
    const { groups } = store.getState().refreshGroups;
    const idx = groups.findIndex(g => g.id === newGroup.id);

    if (groups[idx]) {
      const { sections } = groups[idx];
      // eslint-disable-next-line no-param-reassign
      groups[idx] = {
        ...newGroup,
        sections,
      };
      store.dispatch(setGroupsAction(groups));
    }
  };

  const handleCompAllChange = async eventChange => {
    const compAll = eventChange.target.checked;
    const { groups } = store.getState().refreshGroups;
    if (isVenueAvailable && !focusedPricingGroup) {
      alert('For activating comp all when venue map is available you first need to select a group!');
    }
    if (!isVenueAvailable) {
      store.dispatch(setCompAllEventAction(compAll));
      await updateEvent({ comp_all: compAll, marketplace: compAll ? marketplaceName : '' }, eventInfo.skybox_event_id);
    }
    if (isVenueAvailable && focusedPricingGroup) {
      const { selectedGroup } = store.getState().pricing;
      store.dispatch(setCompAllGroupAction(compAll));
      addAllSections(compAll);
      if (!compAll && marketplaceName === 'ticketnetwork') {
        actions.setGroup({
          ...selectedGroup,
          tnd_sections: [],
          sg_sections: [],
          comp_all: false,
        });
        addAllSections(false);
      } else if (!compAll && marketplaceName === 'seatgeek') {
        actions.setGroup({
          ...selectedGroup,
          tnd_sections: [],
          sg_sections: [],
          comp_all: false,
        });
        addAllSections(false);
      } else if (compAll) {
        actions.setGroup({
          ...selectedGroup,
          comp_all: true,
        });
      }
      store.dispatch(setGroupsAction(setCompAllGroup(groups, focusedPricingGroup, compAll)));
    }
  };

  const handleGroupAttrEdit = (field, value = null) => e => {
    if (e) e.stopPropagation();
    const { selectedGroup } = store.getState().pricing;
    const groupEdited = selectedGroup;
    const newAttrValue = value;
    groupEdited[field] = newAttrValue;
    actions.setSplits(newAttrValue);
    actions.setGroup(groupEdited);
    groupsUpdateReArrange({ ...groupEdited, section: [] });
    validateChanges(groupEdited, field);
  };

  const handleTabChange = (val = 0) => {
    setTabIndex(val);
    store.dispatch(setActiveMarketplace(val === 0 ? 'ticketnetwork' : 'seatgeek'));
  };

  const updateListings = () => {
    if (!dataLN || dataLN.dataLN === null) return;

    const marketData = getVenueData();
    if (((zones && zones.length === 0) || forceVenue) && marketData != null) {
      setForceVenue(false);
      actions.setVenues(marketData);
    }
  };

  useEffect(() => {
    if (isCompAllGroup && focusedPricingGroup) {
      addAllSections(isCompAllGroup, activeMarketplace);
    }
  }, [isCompAllGroup, activeMarketplace]);

  useEffect(() => {
    if (focusedPricingGroupMarketplace) {
      store.dispatch(setActiveMarketplace(focusedPricingGroupMarketplace));
      setTabIndex(MARKETPLACES_TABS[focusedPricingGroupMarketplace]);
    } else {
      store.dispatch(setActiveMarketplace(DEFAULT_MARKETPLACE));
      setTabIndex(MARKETPLACES_TABS[DEFAULT_MARKETPLACE]);
    }
  }, [focusedPricingGroupMarketplace]);

  useEffect(() => {
    if (eventMeta) {
      refetchLN();
    }
  }, [eventMeta]);

  useEffect(() => {
    updateListings();
  }, [dataLN]);

  useEffect(() => {
    if (dataLN) {
      if (dataLN.errorLN === 500 && tabIndex === 1) {
        setTabIndex(0);
      }
      const activeData = activeMarketData(marketplaceName);
      if (activeData && activeData.response && activeData.response.venue && activeData.response.venue.svg) {
        store.dispatch(setVenueAvailableAction(true));
      } else {
        store.dispatch(setVenueAvailableAction(false));
      }
      if (Array.isArray(dataLN) && dataLN.length > 0) {
        const marketZones = {};
        dataLN.forEach(d => {
          if (Array.isArray(d?.response?.zones)) {
            marketZones[d.response.market] = d.response.zones;
          }
        });
        setForceVenue(true);
        actions.setZones(marketZones);
      }
    }
  }, [dataLN]);

  if (isFetchingLN) {
    return <TableLoader />;
  }

  return (
    <Listings
      marketsData={dataLN}
      eventMeta={eventMeta}
      handleTabChange={handleTabChange}
      tabSelected={tabIndex}
      setCompAllChange={handleCompAllChange}
      eventInfo={eventInfo}
      setRefresh={setRefresh}
      isCompAllEvent={isCompAllEvent}
      isCompAllGroup={isCompAllGroup}
      focusedPricingGroup={focusedPricingGroup}
      handleGroupAttrEdit={handleGroupAttrEdit}
    />
  );
};

ListingsContainer.defaultProps = {
  focusedPricingGroupMarketplace: null,
};

ListingsContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  activeMarketplace: PropTypes.string.isRequired,
  eventInfo: PropTypes.object.isRequired,
  eventMeta: PropTypes.object.isRequired,
  focusedPricingGroup: PropTypes.any.isRequired,
  focusedPricingGroupMarketplace: PropTypes.string,
  groupActions: PropTypes.object.isRequired,
  isCompAllEvent: PropTypes.bool.isRequired,
  isCompAllGroup: PropTypes.bool.isRequired,
  isVenueAvailable: PropTypes.bool.isRequired,
  setRefresh: PropTypes.func.isRequired,
  typeListing: PropTypes.string.isRequired,
  zones: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  return {
    activeMarketplace: state.globals.activeMarketplace,
    currTNCompSections: state.pricing.currTNComparisonSections,
    eventInfo: state.pricing.eventInfo,
    eventMeta: state.pricing.eventMeta,
    focusedPricingGroup: state.pricing.ui.focusedPricingGroup,
    focusedPricingGroupMarketplace: state.pricing.focusedPricingGroupMarketplace,
    isCompAllEvent: state.groupsStubhubSeatingState.isCompAllEvent,
    isCompAllGroup: state.groupsStubhubState.isCompAllGroup,
    isVenueAvailable: state.groupsStubhubState.isVenueAvailable,
    marketplaceComps: state.globals.marketplaceComps,
    typeListing: state.pricing.focusedPricingGroupMarketplace,
    zones: state.zones,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(pricingActions, dispatch),
    groupActions: bindActionCreators(refreshGroupActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ListingsContainer);
